export default __webpack_public_path__ + "static/media/background.ada41caa.jpg";